import React, {useState} from 'react';
import {Modal, TextField} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';

type RenameReportModalProps = {
	closeModal: () => void;
	reportName: string;
	renameReport: (name: string) => void;
};

const RenameReportModal = ({closeModal, reportName, renameReport}: RenameReportModalProps): React.JSX.Element => {
	const [name, setName] = useState<string>(reportName);
	const [isNameValid, setIsNameValid] = useState<boolean>(true);

	const validateName = (value: string) => {
		setName(value);
		if (value.length === 0) {
			setIsNameValid(false);
		} else {
			setIsNameValid(true);
		}
	};

	const handleRenameReport = () => {
		renameReport(name);
		closeModal();
	};

	return (
		<Modal size={Modal.SIZE.MEDIUM} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id={'report.rename'} />
			</Modal.Title>
			<Modal.Content>
				<TextField data-cy="input-report-name" onValueChange={validateName} value={name} size="large" width="flex" />
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton
					onPress={handleRenameReport}
					dataCy={'modal-btn-rename-report'}
					disabled={!isNameValid}
				>
					<FormattedMessage id="common.rename" />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id="common.cancel" />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default RenameReportModal;
